export default __webpack_public_path__ + "static/media/select_arrow_hover.cef0bf22.svg";